export default {
    tableList:[
        {
            edit: false,
            riskType: 1,
            name: "险别名称",
            GCTable: true,
            code: "wqe",
            premiumTags: ["100000","200000","300000","400000","500000","600000","700000","800000"],
            tableData: [
              {
                key: "0",
                GCwide: "10万(不含)-100万(含)",
                wideObj: {
                  minAmount: 10,
                  minIsContain: "0",
                  maxAmount: 100,
                  maxIsContain: "1",
                },
                editable: true,
                coverage0: "0.09",
                coverage1: "0.1",
                coverage2: "0.15",
                coverage3: "0.25",
                coverage4: "0.3",
                coverage5: "0.38",
                coverage6: "0.45",
                coverage7: "0.5",
              },
              {
                key: "1",
                GCwide: "100万（不含）-500万（含）",
                wideObj: {
                  minAmount: 100,
                  minIsContain: "0",
                  maxAmount: 500,
                  maxIsContain: "1",
                },
                editable: true,
                coverage0: "0.09",
                coverage1: "0.1",
                coverage2: "0.15",
                coverage3: "0.25",
                coverage4: "0.3",
                coverage5: "0.38",
                coverage6: "0.45",
                coverage7: "0.5",
              },
              {
                key: "2",
                GCwide: "500万（不含）-1000万（含）",
                wideObj: {
                  minAmount: 500,
                  minIsContain: "0",
                  maxAmount: 1000,
                  maxIsContain: "1",
                },
                editable: true,
                coverage0: "0.09",
                coverage1: "0.1",
                coverage2: "0.15",
                coverage3: "0.25",
                coverage4: "0.3",
                coverage5: "0.38",
                coverage6: "0.45",
                coverage7: "0.5",
              },
              {
                key: "3",
                GCwide: "1000万（不含）-1亿（含）",
                wideObj: {
                  minAmount: 1000,
                  minIsContain: "0",
                  maxAmount: 10000,
                  maxIsContain: "1",
                },
                editable: true,
                coverage0: "0.09",
                coverage1: "0.1",
                coverage2: "0.15",
                coverage3: "0.25",
                coverage4: "0.3",
                coverage5: "0.38",
                coverage6: "0.45",
                coverage7: "0.5",
              },
            ],
            columns: [
              {
                title: "工程造价",
                dataIndex: "GCwide",
                width: 400,
                scopedSlots: { customRender: "GCwide" },
              },
              {
                title: "100000",
                dataIndex: "coverage0",
                scopedSlots: { customRender: "coverage0" },
              },
              {
                title: "200000",
                dataIndex: "coverage1",
                scopedSlots: { customRender: "coverage1" },
              },
              {
                title: "300000",
                dataIndex: "coverage2",
                scopedSlots: { customRender: "coverage2" },
              },
              {
                title: "400000",
                dataIndex: "coverage3",
                scopedSlots: { customRender: "coverage3" },
              },
              {
                title: "500000",
                dataIndex: "coverage4",
                scopedSlots: { customRender: "coverage4" },
              },
              {
                title: "600000",
                dataIndex: "coverage5",
                scopedSlots: { customRender: "coverage5" },
              },
              {
                title: "700000",
                dataIndex: "coverage6",
                scopedSlots: { customRender: "coverage6" },
              },
              {
                title: "800000",
                dataIndex: "coverage7",
                scopedSlots: { customRender: "coverage7" },
              },
              {
                title: "操作",
                dataIndex: "operation",
                scopedSlots: { customRender: "operation" },
              },
            ],
            cols: ["coverage0","coverage1","coverage2","coverage3","coverage4","coverage5","coverage6","coverage7"],
            premium: [
                { key: "coverage0", value: "100000" },
                { key: "coverage1", value: "200000" },
                { key: "coverage2", value: "300000" },
                { key: "coverage3", value: "400000" },
                { key: "coverage4", value: "500000" },
                { key: "coverage5", value: "600000" },
                { key: "coverage6", value: "700000" },
                { key: "coverage7", value: "800000" },
            ],
          },
    ],
    myData:{
      "quotationInfo": {
          "name": "测试团意",
          "code": "tuanyi1",
          "status": "0",
          "productDesc": "测试团意",
          "templateCode": "002"
      },
      "labelContents": [
          {
              "modelType": 1,
              "contentTitle": "须知",
              "modelContent": "<p>阿达是否</p>"
          },
          {
              "modelType": 1,
              "contentTitle": "告知",
              "modelContent": "<p><img src=\"http://dicc.nanyanbx.com/ftp/ins_upload/taibaoXuZhi_1608794247561.png\" title=\"file\" alt=\"taibaoXuZhi.png\"/></p>"
          }
      ],
      "quotationCoverageList": [
          {
              "occupationLevel": 1,
              "list": [
                  {
                      "riskType": "1",
                      "coverageName": "意外伤害",
                      "coverageCode": "YXA1001",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "100000",
                              "singlePremium": "27"
                          }
                      ]
                  },
                  {
                      "riskType": "1",
                      "coverageName": "意外伤害医疗扩展保险",
                      "coverageCode": "YXA1004",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "10000",
                              "singlePremium": "38"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "意外住院津贴",
                      "coverageCode": "YXA1006",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "50",
                              "singlePremium": "2"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "猝死",
                      "coverageCode": "YXA1009",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "50000",
                              "singlePremium": "16"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "乘坐民用航空飞机意外身故、残疾",
                      "coverageCode": "YXA1008",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "200000",
                              "singlePremium": "20"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "乘坐客运轨道列车及轮船意外身故、残疾",
                      "coverageCode": "YXA1008",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "100000",
                              "singlePremium": "20"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "乘坐公路公共交通工具意外身故、残疾",
                      "coverageCode": "YXA1008",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "100000",
                              "singlePremium": "20"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "驾乘私家车、搭乘网约车意外身故、残疾",
                      "coverageCode": "YXA1008",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "",
                              "singlePremium": "20"
                          }
                      ]
                  }
              ]
          },
          {
              "occupationLevel": 2,
              "list": [
                  {
                      "riskType": "1",
                      "coverageName": "意外伤害",
                      "coverageCode": "YXA1001",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "100000",
                              "singlePremium": "33"
                          }
                      ]
                  },
                  {
                      "riskType": "1",
                      "coverageName": "意外伤害医疗扩展保险",
                      "coverageCode": "YXA1004",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "10000",
                              "singlePremium": "47"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "意外住院津贴",
                      "coverageCode": "YXA1006",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "50",
                              "singlePremium": "3"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "猝死",
                      "coverageCode": "YXA1009",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "50000",
                              "singlePremium": "16"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "乘坐民用航空飞机意外身故、残疾",
                      "coverageCode": "YXA1008",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "200000",
                              "singlePremium": "20"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "乘坐客运轨道列车及轮船意外身故、残疾",
                      "coverageCode": "YXA1008",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "100000",
                              "singlePremium": "20"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "乘坐公路公共交通工具意外身故、残疾",
                      "coverageCode": "YXA1008",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "100000",
                              "singlePremium": "20"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "驾乘私家车、搭乘网约车意外身故、残疾",
                      "coverageCode": "YXA1008",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "",
                              "singlePremium": "20"
                          }
                      ]
                  }
              ]
          },
          {
              "occupationLevel": 3,
              "list": [
                  {
                      "riskType": "1",
                      "coverageName": "意外伤害",
                      "coverageCode": "YXA1001",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "100000",
                              "singlePremium": "42"
                          }
                      ]
                  },
                  {
                      "riskType": "1",
                      "coverageName": "意外伤害医疗扩展保险",
                      "coverageCode": "YXA1004",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "10000",
                              "singlePremium": "59"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "意外住院津贴",
                      "coverageCode": "YXA1006",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "50",
                              "singlePremium": "4"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "猝死",
                      "coverageCode": "YXA1009",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "50000",
                              "singlePremium": "16"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "乘坐民用航空飞机意外身故、残疾",
                      "coverageCode": "YXA1008",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "200000",
                              "singlePremium": "20"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "乘坐客运轨道列车及轮船意外身故、残疾",
                      "coverageCode": "YXA1008",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "100000",
                              "singlePremium": "20"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "乘坐公路公共交通工具意外身故、残疾",
                      "coverageCode": "YXA1008",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "100000",
                              "singlePremium": "20"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "驾乘私家车、搭乘网约车意外身故、残疾",
                      "coverageCode": "YXA1008",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "",
                              "singlePremium": "20"
                          }
                      ]
                  }
              ]
          },
          {
              "occupationLevel": 4,
              "list": [
                  {
                      "riskType": "1",
                      "coverageName": "意外伤害",
                      "coverageCode": "YXA1001",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "100000",
                              "singlePremium": "69"
                          }
                      ]
                  },
                  {
                      "riskType": "1",
                      "coverageName": "意外伤害医疗扩展保险",
                      "coverageCode": "YXA1004",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "10000",
                              "singlePremium": "108"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "意外住院津贴",
                      "coverageCode": "YXA1006",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "50",
                              "singlePremium": "6"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "猝死",
                      "coverageCode": "YXA1009",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "50000",
                              "singlePremium": "16"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "乘坐民用航空飞机意外身故、残疾",
                      "coverageCode": "YXA1008",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "200000",
                              "singlePremium": "20"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "乘坐客运轨道列车及轮船意外身故、残疾",
                      "coverageCode": "YXA1008",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "100000",
                              "singlePremium": "20"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "乘坐公路公共交通工具意外身故、残疾",
                      "coverageCode": "YXA1008",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "100000",
                              "singlePremium": "20"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "驾乘私家车、搭乘网约车意外身故、残疾",
                      "coverageCode": "YXA1008",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "",
                              "singlePremium": "20"
                          }
                      ]
                  }
              ]
          },
          {
              "occupationLevel": 5,
              "list": [
                  {
                      "riskType": "1",
                      "coverageName": "意外伤害",
                      "coverageCode": "YXA1001",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "100000",
                              "singlePremium": "118"
                          }
                      ]
                  },
                  {
                      "riskType": "1",
                      "coverageName": "意外伤害医疗扩展保险",
                      "coverageCode": "YXA1004",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "10000",
                              "singlePremium": "186"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "意外住院津贴",
                      "coverageCode": "YXA1006",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "50",
                              "singlePremium": "8"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "猝死",
                      "coverageCode": "YXA1009",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "50000",
                              "singlePremium": "16"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "乘坐民用航空飞机意外身故、残疾",
                      "coverageCode": "YXA1008",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "200000",
                              "singlePremium": "20"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "乘坐客运轨道列车及轮船意外身故、残疾",
                      "coverageCode": "YXA1008",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "100000",
                              "singlePremium": "20"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "乘坐公路公共交通工具意外身故、残疾",
                      "coverageCode": "YXA1008",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "100000",
                              "singlePremium": "20"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "驾乘私家车、搭乘网约车意外身故、残疾",
                      "coverageCode": "YXA1008",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "",
                              "singlePremium": "20"
                          }
                      ]
                  }
              ]
          },
          {
              "occupationLevel": 6,
              "list": [
                  {
                      "riskType": "1",
                      "coverageName": "意外伤害",
                      "coverageCode": "YXA1001",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "100000",
                              "singlePremium": "165"
                          }
                      ]
                  },
                  {
                      "riskType": "1",
                      "coverageName": "意外伤害医疗扩展保险",
                      "coverageCode": "YXA1004",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "10000",
                              "singlePremium": "259"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "意外住院津贴",
                      "coverageCode": "YXA1006",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "50",
                              "singlePremium": "13"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "猝死",
                      "coverageCode": "YXA1009",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "50000",
                              "singlePremium": "16"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "乘坐民用航空飞机意外身故、残疾",
                      "coverageCode": "YXA1008",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "200000",
                              "singlePremium": "20"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "乘坐客运轨道列车及轮船意外身故、残疾",
                      "coverageCode": "YXA1008",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "100000",
                              "singlePremium": "20"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "乘坐公路公共交通工具意外身故、残疾",
                      "coverageCode": "YXA1008",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "100000",
                              "singlePremium": "20"
                          }
                      ]
                  },
                  {
                      "riskType": "2",
                      "coverageName": "驾乘私家车、搭乘网约车意外身故、残疾",
                      "coverageCode": "YXA1008",
                      "calculateMethod": 1,
                      "forType": 3,
                      "planList": [
                          {
                              "planCode": "plan1",
                              "planName": "第1个计划",
                              "insuredAmount": "",
                              "singlePremium": "20"
                          }
                      ]
                  }
              ]
          }
      ],
      "quotationPlans": [
          {
              "planCode": "plan1",
              "planName": "第1个计划"
          }
      ],
      "uStr": "MQ=="
  }
}